import { Box, Stack } from "@mui/material";
import { ChevronLeftRounded } from "@mui/icons-material";
import { Custom } from "components";
import { useApp, useNavigation, useTheme } from "contexts";
import { Fields } from "./Fields";
import { useForgotPasswordForm } from "./useForgotPasswordForm";

type Props = {
  onSubmit: (email: string, success: boolean) => void;
};

export const Form = ({ onSubmit, ...props }: Props) => {
  const { t } = useApp();
  const { theme } = useTheme();
  const { goBack } = useNavigation();

  const { values, onChange, handleSubmit } = useForgotPasswordForm(onSubmit);

  return (
    <Box component="form" onSubmit={handleSubmit} mt={theme.spacing.md}>
      <Stack spacing={theme.spacing.md}>
        <Fields values={values} onChange={onChange} />
        <Stack spacing={theme.spacing.md} textAlign="center">
          <Stack direction="row" spacing={theme.spacing.xs}>
            <Custom.Button secondary onClick={goBack}>
              <ChevronLeftRounded />
            </Custom.Button>
            <Custom.Button
              fullWidth
              variant="contained"
              trailing="right"
              sx={{ mt: theme.spacing.md }}
              submit
            >
              {t.action.submit}
            </Custom.Button>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
